/**
 * Config values
 */

import getMuiTheme from 'material-ui/styles/getMuiTheme';

const config = require('./config.json');

// Pull subdomain from hostname
const subdomain = window.location.hostname.split('.')[0].toUpperCase();
// local tunnel usage : lt --port 3000 --subdomain domain
const isDev = window.location.href.includes('localhost') || window.location.href.includes('localtunnel');

// Select config JSON based on subdomain
let conf = config[subdomain] || null;

const themeConfig = subdomain === 'MCCARROLLS' ? config.THEME_MCCARROLLS : config.THEME_DEFAULT;

let washTypes = config.WASH_TYPES;
if (conf.ALLOWED_WASH_TYPES) {
  washTypes = washTypes.filter(w => conf.ALLOWED_WASH_TYPES.indexOf(w.name) !== -1);
}

const Config = {
  CLIENT_NAME: conf.CLIENT_NAME,
  CLIENT_ID: conf.CLIENT_ID,
  PAGE_TITLE: conf.PAGE_TITLE,
  CLIENT_PREFIX: conf.CLIENT_PREFIX,
  PAYMENT_TYPE: conf.PAYMENT_TYPE,
  LOGO_PATH: conf.LOGO_PATH,
  LOCAL_LOGO_PATH: conf.LOCAL_LOGO_PATH,
  FAVICON_PATH: conf.FAVICON_PATH || './default/favicon.ico',

  WASH_TYPES: washTypes,
  ALLOWED_WASH_TYPES: conf.ALLOWED_WASH_TYPES,
  BOOKING_STEPS: config.BOOKING_STEPS[conf.PAYMENT_TYPE],

  BACKEND_API_URL: isDev ? 'http://localhost:3001/' : 'https://api.wipehero.com/',

  STRIPE_API_KEY: isDev ? config.STRIPE.TEST_API_KEY : config.STRIPE.PROD_API_KEY,

  GOOGLE_API_KEY: config.GOOGLE.API_KEY,
  TOKEN_REQUIRED : 401,
  THEME: getMuiTheme(themeConfig),
};

export default Config;



// WEBPACK FOOTER //
// ./src/app/conf.js